document.addEventListener('DOMContentLoaded', function () {
  const uploadOwnRadio = document.getElementById('upload-own');
  const designOnlineRadio = document.getElementById('design-online');
  const uploadSection = document.getElementById('upload-section');
  const qstomizerBlock = document.getElementById('customify-container');
  const addToCart = document.querySelector('.add_to_cart_button');

  function toggleArtworkOption() {
    if (uploadOwnRadio.checked) {
      uploadSection.style.display = 'block';
      qstomizerBlock.style.display = 'none';
      addToCart.style.display = 'block';
    } else if (designOnlineRadio.checked) {
      uploadSection.style.display = 'none';
      qstomizerBlock.style.display = 'block';
      addToCart.style.display = 'none'; // stays hidden for design online
    } else {
      // no selection made
      uploadSection.style.display = 'none';
      qstomizerBlock.style.display = 'none';
      addToCart.style.display = 'none';
    }
  }

  // Reset state on load
  uploadOwnRadio.checked = false;
  designOnlineRadio.checked = false;
  toggleArtworkOption();

  // Watch for changes
  uploadOwnRadio.addEventListener('change', toggleArtworkOption);
  designOnlineRadio.addEventListener('change', toggleArtworkOption);
});
